import Rx from "rxjs/Rx";
import { BaseTypeFilterComponent } from "./base-type-filter.component";

export const searchTypeFilterEnabledSource = new Rx.Subject();
export const searchTypeFilterEnabled$ = searchTypeFilterEnabledSource.asObservable();

/*
 * - Produces searchTypeFilterEnabled$ onClick
 * - Produces visual changes for type filters
 * - Keeps lastTypeFilterIndex up to date
 */
export class SearchPageTypeFilterComponent extends BaseTypeFilterComponent {
    constructor(node) {
        super(node);

        // properties from HTML data arguments
        this.hasCalculator = null;
        this.initialize();
    }

    initialize() {
        if (this.node) {
            this.parseArgs();
        }
    }

    setActiveState() {
        super.setActiveState();
        searchTypeFilterEnabledSource.next(this);
    }

    parseArgs() {
        this.index = parseInt(this.node.data("index"), 10);
        this.hasCalculator = this.node.data("has-calculator") === "True";
    }
}
